import {
    Container,
    Graphics,
    Text,
} from 'pixi.js';
import { FONT_1, SCREEN_HEIGHT } from '../GameConst';
import { walletManager, WALLET_MANAGER_EVENTS } from '../utils/WalletManager';
import { getAPI, postAPI } from '../utils/API';
import { userDataManager } from '../utils/UserDataManager';

export class WalletConnectButton extends Container {
    constructor(){
        super();
        const buttonWidth = SCREEN_HEIGHT * 0.5;
        const buttonHeight = buttonWidth * 0.25;
        const walletConnectButton = new Graphics();
        walletConnectButton.beginFill(0x4DA1FF);
        walletConnectButton.drawRoundedRect(-buttonWidth*0.5, -buttonHeight * 0.5, buttonWidth, buttonHeight, 16);
        walletConnectButton.endFill();
        this.addChild(walletConnectButton);
        this.walletConnectText = new Text('', {
            fontFamily: FONT_1,
            fontSize: 60,
            fill: 'white',
        });
        this.walletConnectText.anchor.set(0.5);
        this.addChild(this.walletConnectText);
        this.setButtonText();

        walletConnectButton.eventMode = 'static';
        walletConnectButton.on('pointerdown', () => {
            this.changeConnect();
        });
        walletManager.event.on(WALLET_MANAGER_EVENTS.CONNECT, () => {
            this.login();
            this.setButtonText();
        });
        walletManager.event.on(WALLET_MANAGER_EVENTS.DISCONNECT, () => {this.setButtonText();});
    }

    async login()
    {
        const message = `hoge:${Date.now()}`;
        const signature = await walletManager.SignMessage(message);
        const loginResult = await postAPI('/auth/login', [
            ['message', message],
            ['signature', signature],
        ]);
        if(!loginResult) return;
        const userData = await getAPI('/users');
        userDataManager.updateUserData(userData);
        walletManager.Disconnect();
    }

    async setButtonText()
    {
        if(walletManager.Connected)
        {
            const address = walletManager.WalletAddress;
            this.walletConnectText.text = `${address.substring(0, 5)}...${address.substring(address.length - 4)}`;
        }
        else
        {
            this.walletConnectText.text = 'ウォレット接続';
        }
    }

    async changeConnect()
    {
        if(walletManager.Connected)
        {
            walletManager.Disconnect();
        }
        else
        {
            walletManager.Connect();
        }
    }
}
